import {
  all,
  call,
  delay,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects';
import { isEmpty } from 'lodash';
import moment from 'moment';

import { get } from '../../utils/request';
import {
  fetchFees,
  fetchFeesFailure,
  fetchFeesSuccess,
  refreshStatementUrl,
} from './actions';
import {
  FETCH_FEES,
  GENERIC_FEE_SCHEDULE,
  REFRESH_STATEMENT_URL,
} from './constants';
import makeSelectMain, { getIsLoanAvailable } from '../Main/selectors';
import makeSelectMobile from '../Mobile/selectors';
import AsyncStorage from '../../utils/AsyncStorage';
import {
  getCookie,
  setCookie,
} from '../../utils/globalHelpers';

export function* fetchFeesSaga({ baseUrl }, { payload }) {
  try {
    const isNativeMobile = yield select(makeSelectMobile('isNativeMobile'));
    const isLoanAvailable = yield select(getIsLoanAvailable());
    const { isLoggedIn, loanNumber } = payload;
    if (isLoggedIn && isLoanAvailable) {
      const {
        asOfDate,
        disclaimer,
        feeSchedule,
        feeStatements,
      } = yield call(get, `${baseUrl}/fees/${loanNumber}`);
      if (!isEmpty(feeStatements)) {
        const {
          statementUrl,
          statementUrlExpiresAt,
        } = feeStatements[0];
        if (isNativeMobile) {
          yield call(AsyncStorage.setItem, 'statementUrlExpiresAt', statementUrlExpiresAt);
        } else {
          setCookie('statementUrlExpiresAt', statementUrlExpiresAt);
        }
        yield put(fetchFeesSuccess({ statementUrl }));
        yield put(refreshStatementUrl());
      } else {
        yield put(fetchFeesSuccess({
          asOfDate,
          disclaimer,
          feeSchedule,
        }));
      }
    }
  } catch {
    yield put(fetchFeesFailure(GENERIC_FEE_SCHEDULE));
  }
}

export function* refreshStatementUrlSaga() {
  try {
    let delayTime = 300000; // 5 min in ms
    const loanNumber = yield select(makeSelectMain('selectedLoan'));
    const isNativeMobile = yield select(makeSelectMobile('isNativeMobile'));
    const isLoggedIn = yield select(makeSelectMain('isLoggedIn'));
    const statementUrlExpiresAt = isNativeMobile
      ? yield call(AsyncStorage.getItem, 'statementUrlExpiresAt')
      : getCookie('statementUrlExpiresAt');
    while (isLoggedIn) {
      yield delay(delayTime);
      const isStillLoggedIn = yield select(makeSelectMain('isLoggedIn'));
      if (!isStillLoggedIn) {
        break;
      }
      const expirationTime = moment(statementUrlExpiresAt).diff(moment());
      // Set delay time to 5 minutes, or less if URL is about to expire
      delayTime = expirationTime > delayTime ? delayTime : expirationTime;
      if (delayTime <= 0) {
        yield put(fetchFees({ isLoggedIn, loanNumber }));
        delayTime = 300000; // 5 min in ms
      }
    }
  } catch {
    yield put(fetchFeesFailure(GENERIC_FEE_SCHEDULE));
  }
}

export default (options) => function* rootSaga() {
  yield all([
    takeLatest(FETCH_FEES, fetchFeesSaga, options),
    takeLatest(REFRESH_STATEMENT_URL, refreshStatementUrlSaga, options),
  ]);
};
